/// src/pages/HistoryPageChina.js
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Ancient_Civilizations_-_Ancient_China.png';

export default function HistoryPageChina() {
  return (
    <TopicPage
      topicKey="Ancient China"
      title="History: Ancient China"
      backgroundImage={bg}
      startRoute="/History-Ancient-China-Go"
      scrollLabels={[
        "The Silk Road and Trade",
        "Chinese Philosophy",
        "The Dynasties",
      ]}

  backRoute="/history-Ancient-Civilizations"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
